<template >
   <div class="header-right">
       <div v-if="menu" class="header-item" @click="goHome">
          <el-button type="default">
            全部应用
          </el-button>
       </div>

       <div v-if="isMain" class="header-item">
          <el-dropdown  trigger="click">
          <el-button type="primary">
            {{nodeName||"默认节点"}}  <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu  class="header-dropdown" slot="dropdown">
            <el-dropdown-item  v-for="item in nodeList" :key="item.value" @click.native="changeNode(item)">{{item.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
       </div>

       <div class="header-item">
         <el-dropdown>
           <span class="header-item-link el-dropdown-link">
               <span class="user-icon"><i class="el-icon-user-solid"></i></span>
               {{userInfo.realname}}
               <i class="el-icon-arrow-down el-icon--right"></i>
           </span>
           <el-dropdown-menu class="header-dropdown" slot="dropdown">
               <el-dropdown-item>账号管理</el-dropdown-item>
               <el-dropdown-item @click.native="logout">注销登录</el-dropdown-item>
           </el-dropdown-menu>
         </el-dropdown>
       </div>
     </div>

  </template>

  <script>
  import config from '@/utils/config';
  import {getUserInfo,deleteKey,setBaseUrl} from '@/utils/store'
  import { setNodeName,getNodeName} from '../utils/store';
  export default {
    name: "RightMenu", //必须要 递归组件的关键，并且要与引入组件的变量名称一致
    props: {
      menu: {
        //菜单 水平  垂直
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        userInfo:[],
        nodeList:[],
        isMain:false,
      };
    },
    computed:{
      nodeName() {
        return getNodeName()
      }
    },
    mounted() {
      this.userInfo = getUserInfo()
      this.nodeList = config.NODE_OPTIONS
      this.isMain = config.isMain
      //console.log(this.menu)
    },
    methods: {
      logout(){
         deleteKey("token")
         deleteKey("UserInfo")
         this.userInfo =  null
         this.$router.push({path:"/login"});
      },
      goHome(){
        this.$router.push({path:"/appList"})
      },

      changeNode(item){
        setBaseUrl(item.value)
        setNodeName(item.label)
       // console.log(val)
        this.$router.go(0)
      }
    },
  };
  </script>



// WEBPACK FOOTER //
// src/components/RightMenu.vue